"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var TypeStyle = require("typestyle");
var TabStyles_1 = require("../styles/TabStyles");
var Sizing = TabStyles_1.TabStyles.Sizing, Colors = TabStyles_1.TabStyles.Colors;
var DividerStyleName = TypeStyle.style({
    border: 'none',
    borderTop: Sizing.BorderWidth + "px solid " + Colors.L3,
    marginBottom: Sizing.ListRowHeight / 2,
    marginLeft: 0,
    marginRight: 0,
    marginTop: Sizing.ListRowHeight / 2,
});
exports.MenuDividerWidget = function () {
    return React.createElement("hr", { "aria-orientation": 'horizontal', className: DividerStyleName, role: 'separator' });
};
exports.MenuDividerWidget.displayName = 'MenuDividerWidget';
//# sourceMappingURL=MenuDividerWidget.js.map